import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {ISignInUserRequest} from "../models/authentication";
import {IRefreshTokenRequest, ITokenResponse, IUser} from "../models/user";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) {}

  signIn(request: ISignInUserRequest, tenantId : string){

    return this.http.post<ITokenResponse>(
      `${environment.baseUrl}/tokens`,
      request,
      {
        withCredentials: true,
        headers: new HttpHeaders({'tenant' : tenantId}) 
      }
    )
  }

  getUser(){
    return this.http.get<IUser>(
      `${environment.baseUrl}/personal/profile`
    )
  }

  refreshToken(request : IRefreshTokenRequest, tenantId: string){
    console.log("refreshing token...")
    return this.http.post<ITokenResponse>(
      `${environment.baseUrl}/tokens/refresh`,
      request,
      {
        withCredentials: true,
        headers: new HttpHeaders({'tenant' : tenantId}) 
      }
    )
  }

}
